import React from 'react';
import Selector, { DEFAULT_SELECTOR_FIELDS } from '../../../../components/Selectors/Selector';
import { useGetReport } from '../utils';
import { ACTIVITY_KINDS } from '../../../../constants';
import { fileTypes, report_type, reportTitles } from '../constants';
import { createReportRequest } from '../../../../api/reportApi';
import { ReportTemplate } from './ReportTemplate';

const initialForm = {
  type_activity: [],
};

export function EntitiesTypeActivityReport() {
  const getReports = async ({ form }) => {
    try {
      return createReportRequest({
        format_type: fileTypes.xlsx,
        report_type,
        kind: reportTitles.entities_type_activity,
        options: { enterprise_activity_types: form.type_activity.map((type) => type.value) },
      });
    } catch (e) {
      console.error(e);
    }
  };
  const {
    form, onChange, makeRequest, dateError,
  } = useGetReport({ initialForm, withDownload: true, getReports });

  const { type_activity } = form;

  const activityOptions = ACTIVITY_KINDS.filter((kind) => kind.id !== 2 && kind.id !== 7);

  return (
    <ReportTemplate
      downloadOptions={{ disableDownload: !type_activity?.length, makeRequest }}
      reportTitle={<>&nbsp;</>}
      error={dateError}
    >
      <Selector
        multiple
        sx={{ width: '540px' }}
        label="Вид деятельности"
        name="type_activity"
        optionField={DEFAULT_SELECTOR_FIELDS}
        request={() => activityOptions}
        value={type_activity}
        onChange={onChange}
      />
    </ReportTemplate>
  );
}
